<template>
<div class="chapter">
<div class="inner_page">
<div style="width:100%; text-align:center;">
<img alt="title" src="images/htit.jpg" style="height: 100%; max-height: 100%; margin:0px 0px 0px 0px; padding:0px 0px 0px 0px; border:0px;"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?46285e1c